import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import url from './../../assets/images/logo_programas_educacionais.png';
import urlWhite from './../../assets/images/logo-uniao-white.png';

interface LogoProgramasEducacionaisProps {
  className?: string;
  width?: number;
  height?: number;
  alt?: string;
  white?: boolean;
}

export const LogoProgramasEducacionais: React.FC<LogoProgramasEducacionaisProps> = ({ className, width, height, alt, white }) => {
  const [size, setSize] = useState<{
    width: string | number;
    height: string | number;
    alt: string;
  }>({
    width: 180,
    height: 'auto',
    alt: 'Programas educacionais',
  });

  useEffect(() => {
    if (width) {
      setSize((prevState) => ({ ...prevState, width, height: 'auto' }));
    } else if (height) {
      setSize((prevState) => ({ ...prevState, width: 'auto', height }));
    }
  }, [width, height]);

  return (
    <img
      src={white ? urlWhite : url}
      width={size.width}
      height={size.height}
      alt={alt || size.alt}
      className={className || ''}
    />
  );
};

LogoProgramasEducacionais.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  alt: PropTypes.string,
  white: PropTypes.bool,
};
